// 👇 Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// 👇 Axios Imports
import axios from 'axios'

import { urlTimeSheetService, urlPieceWorkService } from '@src/endpoints'

import { getUriParams } from '@src/utility/Utils'

export const getExceptionReportData = createAsyncThunk('outsourcedExceptionReport/getExceptionReportData', async params => {
  const uri = getUriParams(params)

  // Convert Date objects to ISO string format if they are Date instances
  let formattedStartDateTime = params.startDateTime
  let formattedEndDateTime = params.endDateTime

  if (params.startDateTime instanceof Date) {
    formattedStartDateTime = params.startDateTime.toISOString()
  }

  if (params.endDateTime instanceof Date) {
    formattedEndDateTime = params.endDateTime.toISOString()
  }

  const FilterModel = {
    profileId: params.profileId || 0,
    fullName: params.fullName || null,
    startDateTime: formattedStartDateTime || null,
    endDateTime: formattedEndDateTime || null,
    punchType: params.punchType || null,
    deviceName: params.deviceName || null,
    siteLocation: params.siteLocation || null,
    clockInGeoLocation: params.clockInGeoLocation || null
  }
  const response = await axios.post(`${urlTimeSheetService}/GetOutsourcedTimeSheetExceptionReport?${uri}`, FilterModel)
  return {
    params,
    data: response.data,
    totalPages: response.data.length > 0 ? response.data[0].totalCount : 0,
    loadedExceptionReport: true
  }
})

export const getAllEmployeesSelect = createAsyncThunk('outsourcedExceptionReport/getAllEmployeesSelect', async () => {
  const response = await axios.get(`${urlTimeSheetService}/GetAllEmployeesSelect?isTempWorker=true`)
  const allEmployees = [{ value: null, label: 'Select...' }, ...response.data.data]
  return allEmployees
})

export const updateOutsourcedExceptionStatus = async (statusUpdateModel) => {
  await axios.post(`${urlPieceWorkService}/updatePieceWorkStatus`, statusUpdateModel)
  return statusUpdateModel
}

export const outsourcedExceptionReportSlice = createSlice({
  name: 'outsourcedExceptionReport',
  initialState: {
    exceptionReportData: [],
    exceptionReportTotal: 0,
    loadedExceptionReport: false,
    allEmployees: []
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getExceptionReportData.pending, (state) => {
        state.loadedExceptionReport = false
      })
      .addCase(getExceptionReportData.fulfilled, (state, action) => {
        state.loadedExceptionReport = action.payload.loadedExceptionReport
        state.exceptionReportData = action.payload.data
        state.exceptionReportTotal = action.payload.totalPages
      })
      .addCase(getAllEmployeesSelect.fulfilled, (state, action) => {
        state.allEmployees = action.payload
      })
  }
})

export default outsourcedExceptionReportSlice.reducer
